import { OCT_INVOICE_TRADING_URL } from "../../config";
import { createHttpHeaderWithAuthorization } from "../services/http-header";
import { callWithRetry } from "../services/callWithRetry";

export const incassaSubitoConstants = {
  GET_ELIGIBLE_INVOICES_START: "GET_ELIGIBLE_INVOICES_START",
  GET_ELIGIBLE_INVOICES_SUCCESS: "GET_ELIGIBLE_INVOICES_SUCCESS",
  GET_ELIGIBLE_INVOICES_ERROR: "GET_ELIGIBLE_INVOICES_ERROR",

  GET_SUPPLIER_OVERVIEW_START: "GET_SUPPLIER_OVERVIEW_START",
  GET_SUPPLIER_OVERVIEW_SUCCESS: "GET_SUPPLIER_OVERVIEW_SUCCESS",
  GET_SUPPLIER_OVERVIEW_ERROR: "GET_SUPPLIER_OVERVIEW_ERROR"
};

export function getPrivacyIncassaSubito() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const companyId = getState().main.clientIdSelected;

    let request = {
      method: "get",
      url: `${OCT_INVOICE_TRADING_URL}/${companyId}/overview`,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: incassaSubitoConstants.GET_SUPPLIER_OVERVIEW_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: incassaSubitoConstants.GET_SUPPLIER_OVERVIEW_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: incassaSubitoConstants.GET_SUPPLIER_OVERVIEW_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: incassaSubitoConstants.GET_SUPPLIER_OVERVIEW_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getTotalEligibleInvoices() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const companyId = getState().main.clientIdSelected;

    let request = {
      method: "get",
      url: `${OCT_INVOICE_TRADING_URL}/${companyId}/eligibleInvoices/overview `,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: incassaSubitoConstants.GET_ELIGIBLE_INVOICES_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: incassaSubitoConstants.GET_ELIGIBLE_INVOICES_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: incassaSubitoConstants.GET_ELIGIBLE_INVOICES_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: incassaSubitoConstants.GET_ELIGIBLE_INVOICES_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
